/**
 * Dispatches events to the right Foundation.Storable.Bucket instances when the
 * underlying data store has changed. This is a singleton object, so use the
 * sharedInstance function instead of this constructor.
 * @constructor
 */
Foundation.Storable.StorageEventDispatcher = function () {
    /**
     * @private
     * @type {Array.<Foundation.Storable.StorageEventDispatcher.Callback>}
     */
    this._callbacks = []

    /**
     * IE will emit storage events on the same window object that
     * caused the change, unlike other browsers. 
     * @private
     * @type {boolean}
     */
    this._browserEmitsSameTabStorageEvents = false

    this._boundStorageEventHandler = this._storageEventHandler.bind(this);
    Foundation.Storable.StorageEventDispatcher._addEventListener(window, "storage", this._boundStorageEventHandler);

    this._detectSameTabStorageEvents()
}

/**
 * Return the singleton instance.
 * @return {Foundation.Storable.StorageEventDispatcher}
 */
Foundation.Storable.StorageEventDispatcher.sharedInstance = function () {
    var sharedEventDispatcher = Foundation.Storable.StorageEventDispatcher._sharedInstance
        || new Foundation.Storable.StorageEventDispatcher();
    return Foundation.Storable.StorageEventDispatcher._sharedInstance = sharedEventDispatcher;
}

/**
 * Dependency injection point for addEventListener spy.
 * @private
 */
Foundation.Storable.StorageEventDispatcher._addEventListener = Foundation.addEventListener;

/**
 * @param {StorageEvent|Object} e
 */
Foundation.Storable.StorageEventDispatcher.prototype._storageEventHandler = function (e) {
    this._callbacks.forEach(function (callback) {
        callback.callIfChecksPass(e)
    })
}

/**
 * @param {RegExp} re
 * @param {function(string,string,string)} cb
 */
Foundation.Storable.StorageEventDispatcher.prototype.addListenerForKeysMatching = function (re, cb) {
    this._callbacks.push(new Foundation.Storable.StorageEventDispatcher.Callback(re, cb))
}

/**
 * @param {string} key
 */
Foundation.Storable.StorageEventDispatcher.prototype.removeListenersForKey = function (key) {
    this._callbacks = this._callbacks.filter(function (callback) {
        return !(callback.matchesKey(key))
    })
}

/**
 * Mimic a Storage event.
 * @param {string} key
 * @param {string?} oldValue
 * @param {string?} newValue
 */
Foundation.Storable.StorageEventDispatcher.prototype.mimicStorageEvent = function (key, oldValue, newValue) {
    if (this._browserEmitsSameTabStorageEvents) return

    this._storageEventHandler({
        "key": key,
        "oldValue": oldValue,
        "newValue": newValue,
        "url": window.location.href
    })
}

/**
 * @private
 */
Foundation.Storable.StorageEventDispatcher.prototype._detectSameTabStorageEvents = function () {
    var testKey = `F.S.SED.sameTabStorageTest${(new Date()).getTime()}`

    if (window.sessionStorage) {
        this.addListenerForKeysMatching(/^F\.S\.SED\.sameTabStorageTest/, function () {
            this._browserEmitsSameTabStorageEvents = true
            this.removeListenersForKey(testKey)
            window.sessionStorage.removeItem(testKey)
        }.bind(this))
        window.sessionStorage.setItem(testKey, "1")
    }
}


/**
 * @constructor
 * @param {RegExp} re
 * @param {function(string,string,string)} cb
 * @private
 */
Foundation.Storable.StorageEventDispatcher.Callback = function (re, cb) {
    this._re = re
    this._cb = cb
}

/**
 * Determines if this callback should be called for this storage event.
 * @param {StorageEvent|Object} e
 * @return {boolean}
 */
Foundation.Storable.StorageEventDispatcher.Callback.prototype.eventMatchesKey = function (e) {
    return this.matchesKey(e.key)
}

/**
 * Determine if the given string matches the pattern for this callback.
 * @param {string} key
 * @return {boolean}
 */
Foundation.Storable.StorageEventDispatcher.Callback.prototype.matchesKey = function (key) {
    return !!(key.match(this._re))
}

/**
 * Calls the callback if the event matches.
 * @param {StorageEvent|Object} e
 */
Foundation.Storable.StorageEventDispatcher.Callback.prototype.callIfChecksPass = function (e) {
    if (this.eventMatchesKey(e) && e["oldValue"] !== e["newValue"]) {
        // IE likes to set these values to the empty string instead of null
        // when the value doesn't exist. Let's normalize this to null.
        var oldValue = e["oldValue"] || null
        var newValue = e["newValue"] || null

        this._cb.call(window, e["key"], oldValue, newValue)
    }
}

